var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 24,
    viewBox: "0 0 11 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46854 13.9382H1.53146C1.2934 13.9382 1.16047 14.1896 1.3079 14.3612L5.27644 18.963C5.39003 19.0947 5.60876 19.0947 5.72356 18.963L9.6921 14.3612C9.83953 14.1896 9.7066 13.9382 9.46854 13.9382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6921 10.6388L5.72356 6.03702C5.60997 5.9053 5.39124 5.9053 5.27644 6.03702L1.3079 10.6388C1.16047 10.8104 1.2934 11.0617 1.53146 11.0617H9.46854C9.7066 11.0617 9.83953 10.8104 9.6921 10.6388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.468817ff8f6dd8a054c4af499b6caab5.svg";
export { ForwardRef as ReactComponent };